export default __webpack_public_path__ + "static/media/Holistic-Director_A4-Flyer_Final.b40e98d2.jpg";